import React from "react";
import { ExclusionModal } from "./transactions/modals/ExclusionModal";
import { SectionEditModal } from "./transactions/modals/SectionEditModal";
import { PanUpdateModal } from "./transactions/modals/PanUpdateModal";
import { PartyNameModal } from "./transactions/modals/PartyNameModal";
import { TdsAmountModal } from "./transactions/modals/TdsAmountModal";
import { BulkPartyModal } from "./transactions/modals/BulkPartyModal";

export const TransactionModals = ({
  exclusionModal, setExclusionModal, exclusionReason, setExclusionReason, handleExclude,
  sectionModal, setSectionModal, newSection, setNewSection, rateChoice, setRateChoice,
  handleSectionUpdate,
  panModal, setPanModal, newPan, setNewPan, handlePanUpdate,
  partyNameModal, setPartyNameModal, newPartyName, setNewPartyName,
  newPartyPan, setNewPartyPan, handlePartyNameUpdate,
  showPartySearch, setShowPartySearch, partySearchQuery, setPartySearchQuery,
  tdsModal, setTdsModal, newAmount, setNewAmount, newTdsAmount, setNewTdsAmount,
  handleTdsAmountUpdate, getAffectedCount,
  bulkPartyModal, setBulkPartyModal, bulkPartyName, setBulkPartyName, bulkPan, setBulkPan,
  handleBulkPartyUpdate,
  selectedTxns, existingParties, transactions,
}) => (
  <>
    <ExclusionModal
      exclusionModal={exclusionModal}
      setExclusionModal={setExclusionModal}
      exclusionReason={exclusionReason}
      setExclusionReason={setExclusionReason}
      handleExclude={handleExclude}
      selectedTxns={selectedTxns}
    />
    <SectionEditModal
      sectionModal={sectionModal}
      setSectionModal={setSectionModal}
      newSection={newSection}
      setNewSection={setNewSection}
      rateChoice={rateChoice}
      setRateChoice={setRateChoice}
      handleSectionUpdate={handleSectionUpdate}
      selectedTxns={selectedTxns}
    />
    <PanUpdateModal
      panModal={panModal}
      setPanModal={setPanModal}
      newPan={newPan}
      setNewPan={setNewPan}
      handlePanUpdate={handlePanUpdate}
    />
    <PartyNameModal
      partyNameModal={partyNameModal}
      setPartyNameModal={setPartyNameModal}
      newPartyName={newPartyName}
      setNewPartyName={setNewPartyName}
      newPartyPan={newPartyPan}
      setNewPartyPan={setNewPartyPan}
      showPartySearch={showPartySearch}
      setShowPartySearch={setShowPartySearch}
      partySearchQuery={partySearchQuery}
      setPartySearchQuery={setPartySearchQuery}
      handlePartyNameUpdate={handlePartyNameUpdate}
      existingParties={existingParties}
    />
    <TdsAmountModal
      tdsModal={tdsModal}
      setTdsModal={setTdsModal}
      newAmount={newAmount}
      setNewAmount={setNewAmount}
      newTdsAmount={newTdsAmount}
      setNewTdsAmount={setNewTdsAmount}
      handleTdsAmountUpdate={handleTdsAmountUpdate}
      getAffectedCount={getAffectedCount}
      transactions={transactions}
    />
    <BulkPartyModal
      bulkPartyModal={bulkPartyModal}
      setBulkPartyModal={setBulkPartyModal}
      bulkPartyName={bulkPartyName}
      setBulkPartyName={setBulkPartyName}
      bulkPan={bulkPan}
      setBulkPan={setBulkPan}
      handleBulkPartyUpdate={handleBulkPartyUpdate}
      selectedTxns={selectedTxns}
    />
  </>
);
